export default function AuditField({ label, value, className = "" }) {
  return (
    <div className={`p-3 rounded-[var(--hp-radius-md)] bg-surface-muted/40 border border-workspace/60 space-y-1 transition-colors hover:border-workspace ${className}`}>
      <p className="text-[11px] uppercase tracking-wider font-semibold text-subtle truncate">{label}</p>
      <p className="text-sm font-semibold text-primary break-words">{value || "—"}</p>
    </div>
  );
}
 